// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + ({"34":"application","886":"create"}[chunkId] || chunkId) + "." + {"34":"aa0446dc","169":"5d7f3600","886":"3afe5ad7"}[chunkId] + ".js";
};